import {combineReducers} from "redux"
import templateData from "./templateReducer"
import userData from "./userReducer"

export default combineReducers({
    templateData,
    userData,
})
